import React, { Component, Fragment } from 'react'
import { Button} from 'material-ui'
import Dialog, { DialogActions, DialogContent, DialogTitle, DialogContentText} from 'material-ui/Dialog'
import { withStyles } from 'material-ui/styles'

const styles = theme => ({

});

class DialogAlert extends Component {
  propTypes: {
    open: React.PropTypes.boolean.isRequired
  }

  handleClose = () => {
    this.props.onClose();
  };

  render() {
    return <Fragment>
      <Dialog open={this.props.open}  aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
        <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{this.props.message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} color="primary" autoFocus>Okay</Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  }
}

export default withStyles(styles)(DialogAlert)



// WEBPACK FOOTER //
// ./src/Components/Dialogs/DialogAlert.js